import { tenantActionTypes } from './tenant.types';

export const selectTenantError = state => state.tenant.error;

// message: string amigável para o usuário (ex.: "empresa não encontrada"),
// já traduzida -- ver assets/api/http-client.js, que dispara isso quando a
// API responde 400/404 de resolução de tenant.
export const setTenantError = (message) => ({
  type: tenantActionTypes.SET_TENANT_ERROR,
  payload: message
});

export const clearTenantError = () => ({
  type: tenantActionTypes.CLEAR_TENANT_ERROR
});
